export default __webpack_public_path__ + "static/media/ABChanel-PB-SemiBold-S.8295b4ca.ttf";